/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ProductCardSearch } from '@/components/blocks/ProductCardSearch';
import { useUser } from '@/data/User';
import { ContentContext } from '@/data/context/content';
import { ID } from '@/data/types/Basic';
import { ProductType } from '@/data/types/Product';
import { getContractIdFromContext } from '@/utils/getContractIdFromContext';
import { FC, useContext, useEffect } from 'react';

interface InfoElectronico {
	offerDeContado?: string;
	strikedDeContado?: string;
}

export const ProductSearch: FC<{
	product: ProductType;
	infoElectronico?: InfoElectronico;
	clickAction?: () => void;
}> = ({ product, clickAction }) => {
	const { user } = useUser();
	const contract = getContractIdFromContext(user?.context);
	const { onNotify } = useContext(ContentContext) as {
		onNotify: (id: ID, contract: string, product?: ProductType) => void;
	};

	useEffect(() => {
		if (onNotify && product) {
			onNotify(product.partNumber, contract, product);
		}
	}, [product]); // eslint-disable-line react-hooks/exhaustive-deps

	return <ProductCardSearch product={product} clickAction={clickAction} />;
};
